import { MILLION } from 'constants/dataSets';
import {
  ADDRESS_BUILDING,
  ADDRESS_CITY,
  ADDRESS_COORDINATES,
  ADDRESS_COUNTRY,
  ADDRESS_POST_CODE,
  ADDRESS_STATE,
  ADDRESS_STREET,
  DATE_CLOSED,
  DATE_OPENED,
  END_DATE,
  EQUITY_SHAREHOLDING,
  EU_TAXONOMY_CODE,
  FINANCIAL_CONTROL,
  FINISHED_GOOD_STOCK_AMOUNT,
  FINISHED_GOOD_STOCK_AMOUNT_CURRENCY,
  GROSS_MARGIN_ROLLING_AMOUNT,
  GROSS_MARGIN_ROLLING_CURRENCY,
  NACE_CODE,
  NACE_SECTION,
  NET_BOOK,
  NET_BOOK_CURRENCY,
  NUMBER_OF_EMPLOYEES,
  OLD_ORG_PATH,
  ORG_PATH,
  OWNERSHIP,
  PROFIT_CENTRE_NAME, PROFIT_CENTRE_UNIQUE_IDENTIFIER,
  REVENUE_ROLLING_AMOUNT,
  REVENUE_ROLLING_CURRENCY,
  START_DATE,
  VALUE_CHAIN_LIST,
  VALUE_CHAIN_SECTION,
} from 'constants/formFields';
import { DATA_SETS_DATE_FORMAT, DATE_FORMAT_ISO } from 'constants/general';
import dayjs from 'dayjs';

import type IProfitCenterRecordRequest from 'store/slices/dataSets/interfaces/IProfitCenterRecordRequest';
import type { IGetRequestDataForProfitCentre } from './interfaces/IGetRequestDataForProfitCentre';

function getRequestDataForProfitCentreUpdate({
  values, recordId, valueChainForm,
}: IGetRequestDataForProfitCentre): IProfitCenterRecordRequest {
  return {
    [PROFIT_CENTRE_NAME]: values?.[PROFIT_CENTRE_NAME] || null,
    [REVENUE_ROLLING_AMOUNT]: values?.[REVENUE_ROLLING_AMOUNT] ? {
      amount: Number(values?.[REVENUE_ROLLING_AMOUNT]) * MILLION,
      currency: values?.[REVENUE_ROLLING_CURRENCY],
    } : null,
    [GROSS_MARGIN_ROLLING_AMOUNT]: values?.[GROSS_MARGIN_ROLLING_AMOUNT] ? {
      amount: Number(values?.[GROSS_MARGIN_ROLLING_AMOUNT]) * MILLION,
      currency: values?.[GROSS_MARGIN_ROLLING_CURRENCY],
    } : null,
    [FINISHED_GOOD_STOCK_AMOUNT]: values?.[FINISHED_GOOD_STOCK_AMOUNT] ? {
      amount: Number(values?.[FINISHED_GOOD_STOCK_AMOUNT]) * MILLION,
      currency: values?.[FINISHED_GOOD_STOCK_AMOUNT_CURRENCY],
    } : null,
    [START_DATE]: values?.[START_DATE]
      ? new Date(dayjs(values?.[START_DATE], DATA_SETS_DATE_FORMAT).format(DATE_FORMAT_ISO))
      : null,
    [END_DATE]: values?.[END_DATE]
      ? new Date(dayjs(values?.[END_DATE], DATA_SETS_DATE_FORMAT).format(DATE_FORMAT_ISO))
      : null,
    [DATE_OPENED]: values?.[DATE_OPENED]
      ? new Date(dayjs(values?.[DATE_OPENED], DATA_SETS_DATE_FORMAT).format(DATE_FORMAT_ISO))
      : null,
    [DATE_CLOSED]: values?.[DATE_CLOSED]
      ? new Date(dayjs(values?.[DATE_CLOSED], DATA_SETS_DATE_FORMAT).format(DATE_FORMAT_ISO))
      : null,
    ...(!recordId || valueChainForm !== true ? {
      [VALUE_CHAIN_SECTION]: `${values?.[VALUE_CHAIN_LIST]?.value}. ${values?.[VALUE_CHAIN_SECTION]?.value}` || null,
    } : {}),
    [OWNERSHIP]: values?.[OWNERSHIP]?.value || null,
    [EQUITY_SHAREHOLDING]: Number(values?.[EQUITY_SHAREHOLDING]) || null,
    [FINANCIAL_CONTROL]: Number(values?.[FINANCIAL_CONTROL]) || null,
    [NUMBER_OF_EMPLOYEES]: Number(values?.[NUMBER_OF_EMPLOYEES]) || null,
    [NACE_SECTION]: values?.[NACE_SECTION]?.value || null,
    [NACE_CODE]: values?.[NACE_CODE]?.value || null,
    [EU_TAXONOMY_CODE]: values?.[EU_TAXONOMY_CODE] || null,
    [ADDRESS_COUNTRY]: values?.[ADDRESS_COUNTRY]?.value || null,
    [ADDRESS_STATE]: values?.[ADDRESS_STATE]?.label || null,
    [ADDRESS_POST_CODE]: values?.[ADDRESS_POST_CODE] || null,
    [ADDRESS_CITY]: values?.[ADDRESS_CITY]?.label || null,
    [ADDRESS_STREET]: values?.[ADDRESS_STREET] || null,
    [ADDRESS_BUILDING]: values?.[ADDRESS_BUILDING] || null,
    [ADDRESS_COORDINATES]: values?.[ADDRESS_COORDINATES] || null,
    [NET_BOOK]: values?.[NET_BOOK] ? {
      amount: Number(values?.[NET_BOOK]) * MILLION,
      currency: values?.[NET_BOOK_CURRENCY],
    } : null,
    [ORG_PATH]: values?.[ORG_PATH] || null,
    ...(recordId && { [OLD_ORG_PATH]: (recordId ? values?.[OLD_ORG_PATH] : values?.[ORG_PATH]) || null }),
    ...(!recordId && { [PROFIT_CENTRE_UNIQUE_IDENTIFIER]: values?.[PROFIT_CENTRE_UNIQUE_IDENTIFIER] }),
    ...(recordId && { id: Number(recordId) }),
  };
}

export default getRequestDataForProfitCentreUpdate;
